import React from 'react';
import PropTypes from 'prop-types';
import {
  Skeleton,
  SkeletonLine,
  SkeletonBlock,
  TableCell,
  TableRow
} from '@one-thd/sui-atomic-components';

export const QuickEstimateItemPlaceholder = ({ itemIndex }) => {
  return (
    <TableRow data-testid={`quick-estimate-item-placeholder-${itemIndex}`}>
      <TableCell className="sui-bg-primary sui-text-left sui-px-1 sui-py-2">
        <div className="sui-flex sui-gap-2 sui-pointer-events-none">
            <div className="sui-w-12 sui-min-w-12 sui-align-middle">
                <Skeleton disablePadding PaperProps={{ className: 'sui-w-full', variant: 'shadow' }}>
                    <SkeletonBlock aspect="wide" height="36" />
                </Skeleton>
            </div>
            <Skeleton disablePadding PaperProps={{ className: 'sui-w-full', variant: 'shadow' }}>
                <SkeletonLine variant="single" />
            </Skeleton>
        </div>
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-center sui-px-2 sui-py-2">
        <Skeleton disablePadding PaperProps={{ className: 'sui-w-full', variant: 'shadow' }}>
          <SkeletonLine  variant="single" />
        </Skeleton>
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-center sui-px-2 sui-py-2">
        <Skeleton disablePadding PaperProps={{ className: 'sui-w-full', variant: 'shadow' }}>
          <SkeletonLine variant="single" />
        </Skeleton>
      </TableCell>
    </TableRow>
  );
};

QuickEstimateItemPlaceholder.displayName = 'QuickEstimateItemPlaceholder';

QuickEstimateItemPlaceholder.propTypes = {
  itemIndex: PropTypes.number
};

QuickEstimateItemPlaceholder.defaultProps = {
  itemIndex: 0
};
